/**
 * DM-7976: route container for the Charity Verification page. Binds the
 * decision mutation into the presentation component's callback prop and
 * gates it on the viewer's groups: every admin group may read the queue, only
 * admin and admin-operator may decide.
 */

import { useAuth } from '../components/AuthProvider';
import { useDecideCharityVerification } from '../hooks/useAdminOps';
import CharityVerification from './CharityVerification';
import { CHARITY_VERIFICATION_DECISION_GROUPS } from './charityVerification.logic';

export default function CharityVerificationContainer() {
  const { hasRole } = useAuth();
  const decide = useDecideCharityVerification();

  return (
    <CharityVerification
      canDecide={hasRole(...CHARITY_VERIFICATION_DECISION_GROUPS)}
      onDecision={(input, handlers) => decide.mutate(input, handlers)}
      isDecisionPending={decide.isPending}
    />
  );
}
